export const enum RouteHub {
  loginWeb = 'login-web',
}
